import { useEffect, useState } from "react";
import { TutorCredentialsView } from "../../firestore/Types/TutorCredentialsSchema";
import { updateTutorCredentialsWWCC } from "../../firestore/Functions/tutorCredentialFunctions";
import { Textbox } from "../Common/Textbox";

export function WWCC({ tutorCredentials, refreshApprovals, handleRefresh, setTutorCredentials }: { tutorCredentials: TutorCredentialsView, refreshApprovals: () => void, handleRefresh: () => void, setTutorCredentials: (tutorCredentials: TutorCredentialsView) => void }) {
    const [isEditable, setIsEditable] = useState(false);
    const [WWCCNumber, setWWCCNumber] = useState("");
    const [isSaving, setIsSaving] = useState(false);
    const [isEdited, setIsEdited] = useState(false);

    const handleWWCCChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setWWCCNumber(e.target.value);
    }

    const handleSave = async () => {
        setIsSaving(true);
        if (tutorCredentials === undefined) {
            return;
        }
        const newCredential = { WWCCverified: tutorCredentials.WWCCverified, WWCC: WWCCNumber } as TutorCredentialsView;
        setTutorCredentials(newCredential);
        await updateTutorCredentialsWWCC(newCredential);
        await refreshApprovals();
        setIsSaving(false);
    }

    useEffect(() => {
        setWWCCNumber(tutorCredentials?.WWCC ?? "");
        setIsEditable(tutorCredentials?.WWCCverified === false);
    }, [tutorCredentials]);

    useEffect(() => {
        if (WWCCNumber !== tutorCredentials?.WWCC) {
            setIsEdited(true);
        }
        else {
            setIsEdited(false);
        }
    }, [WWCCNumber, tutorCredentials]);

    return (
        <div className="section-box p-4 grow gap-4">
            <div className="flex flex-row">
                <h3 className="section-title">WWCC Verification</h3>
            </div>
            <Textbox label="WWCC" name="WWCCNumber" value={WWCCNumber} isReadonly={!isEditable} onValueChange={handleWWCCChange} />
            {isEdited && <button className="primary-button" onClick={handleSave}>Save</button>}
            {isSaving && <div>Saving...</div> }
        </div>
    );
}